import { Country, Result } from 'types';
import fetch from 'utils/fetch';

export async function postRegistration(values: object): Promise<boolean> {
  await fetch(`/api/user/register-online`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(values),
  });

  return true;
}

/**
 *
 */
export async function fetchCountryCodes(): Promise<Result<Country>> {
  const response = await fetch(`/api/country/list`, {
    method: 'POST',
    headers: new Headers({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      sort: [
        {
          field: 'order',
          order: 'ASC',
        },
        {
          field: 'name',
          order: 'ASC',
        },
      ],
      size: 500,
    }),
  });

  const countries = await response.json();

  return countries;
}
